import { IZone, IZoneData } from "@/entities";

export class Zone implements IZone {
  readonly id?: number;
  readonly description?: string;

  constructor(data: IZoneData) {
    this.id = data.id;
    this.description = data.description;
  }
}
